import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { styles } from "./styles";

const {
  container,
  messageContainer,
  messagePrimary,
  messageSecondary,
  icon,
} = styles;

const Logout = (props) => {
  const { t } = useTranslation();
  return (
    <div style={container}>
      <div style={messageContainer}>
        <FontAwesomeIcon icon={faLock} style={icon} />
        <Typography style={messagePrimary}>{t('messages.logout.loggedOut')}</Typography>
        <NavLink to={'/glc'} >
          <Typography style={messageSecondary}>{t("labels.header.login")}</Typography>
        </NavLink>
      </div>
    </div>
  );
};

export default Logout;
